import '#ui-library-public-path';

import { apiFetchAppEnvConfig } from '#api/env.api';

const MAX_RELOAD_ATTEMPTS = 3;
const RELOAD_DELAY_MS = 3000;
const RELOAD_ATTEMPTS_KEY = 'wallboard:app-load-attempts';

const getReloadAttempts = (): number => Number(window.sessionStorage.getItem(RELOAD_ATTEMPTS_KEY) ?? 0);

/**
 * A failed native `import()` is memoized by the browser, so retrying the same import never
 * re-downloads the chunk. Reload the page instead, a bounded number of times per session, to
 * recover from a transient network failure or a deploy that replaced the hashed chunks.
 */
const retryAppLoad = (): void => {
  const attempts = getReloadAttempts();

  if (attempts >= MAX_RELOAD_ATTEMPTS) {
    return;
  }

  window.sessionStorage.setItem(RELOAD_ATTEMPTS_KEY, String(attempts + 1));
  setTimeout(() => window.location.reload(), RELOAD_DELAY_MS);
};

apiFetchAppEnvConfig()
  .then((data) => {
    window.FETCHED_ENV_DATA = data;
  })
  .catch((error) => {
    console.error('There is no env.json:', error);
  })
  .finally(() => {
    import('#index')
      .then(() => window.sessionStorage.removeItem(RELOAD_ATTEMPTS_KEY))
      .catch((error) => {
        console.error(error);
        retryAppLoad();
      });
  });
